import { h, Component } from 'preact';
import UsedVehicleConversionForm from './UsedVehicleConversionForm';
import PropTypes from 'prop-types';

class UsedVehicleConversionFormApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmittingForm: false,
      errorSendingForm: false,
      showOverlay: false,
    };

    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleCloseOverlay(e) {
    this.setState({ showOverlay: false });
  }

  handleSubmit(e, params) {
    this.setState({ isSubmittingForm: true });
    return serviceConversion
      .convert(params)
      .then(() => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: false,
        });
      })
      .catch(error => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: true,
        });
        console.error(error);
      })
      .then(() => {
        this.setState({
          showOverlay: true,
        });
      });
  }

  render() {
    const { isSubmittingForm, errorSendingForm, showOverlay } = this.state;
    const { formId, mainPhrase } = this.props;

    return (
      <UsedVehicleConversionForm
        formId={formId}
        isSubmittingForm={isSubmittingForm}
        errorSendingForm={errorSendingForm}
        showOverlay={showOverlay}
        handleSubmit={this.handleSubmit}
        handleCloseOverlay={this.handleCloseOverlay}
        mainPhrase={mainPhrase}
        linkPrivacyPolicy={this.props.linkPrivacyPolicy}
        units={this.props.units}
        unit={this.props.unit}
        product={this.props.product}
        channel={this.props.channel}
        category={this.props.category}
        brand={this.props.brand}
        country={this.props.country}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        zflow={this.props.zflow}
        contactsWithDynamicRequired={this.props.contactsWithDynamicRequired}
        shouldShowDataPermissions={this.props.shouldShowDataPermissions}
        dataPermissionsCustomText={this.props.dataPermissionsCustomText}
        showFandiButton={this.props.showFandiButton}
        showLocationFields={this.props.showLocationFields}
        showLabels={this.props.showLabels}
        showMessageField={this.props.showMessageField}
        showCustomerType={this.props.showCustomerType}
      />
    );
  }
}

UsedVehicleConversionFormApp.defaultProps = {
  mainPhrase:
    'Preencha o formulário abaixo para receber o contato de um de nossos especialistas:',
  units: [],
  brand: '-',
  showUnits: true,
  showCpf: false,
  zflow: false,
  contactsWithDynamicRequired: false,
  shouldShowDataPermissions: false,
  showFandiButton: false,
  showLocationFields: false,
  showLabels: false,
  showCustomerType: false,
};

UsedVehicleConversionFormApp.propTypes = {
  formId: PropTypes.string.isRequired,
  mainPhrase: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  unit: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  country: PropTypes.string,
  showUnits: PropTypes.bool,
  showCustomerType: PropTypes.bool,
  showCpf: PropTypes.bool,
  zflow: PropTypes.bool,
  contactsWithDynamicRequired: PropTypes.bool,
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  showFandiButton: PropTypes.bool,
  showLocationFields: PropTypes.bool,
  showLabels: PropTypes.bool,
  showMessageField: PropTypes.bool,
};

export default UsedVehicleConversionFormApp;
